import { useQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

export const useGetGroupQuery = (uid: string) => {
  return useQuery({
    queryKey: ['useGetGroupQuery', uid],
    queryFn: () => Api.users.getUserGroup(uid),
    enabled: !!uid,
  });
};
